module.exports = __webpack_public_path__ + "img/intense.68eba75c.jpg";